import React from 'react'

function Active() {
  return (
    <div>    <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.00012 4.42188V4.42188C11.8051 4.42188 14.0784 6.69512 14.0784 9.50012V9.50012C14.0784 12.3051 11.8051 14.5784 9.00012 14.5784V14.5784C6.19512 14.5784 3.92188 12.3051 3.92188 9.50012V9.50012C3.92188 6.69512 6.19512 4.42188 9.00012 4.42188Z"
      stroke="#321083"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 9.78169V6.96094"
      stroke="#321083"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.99925 11.785C8.937 11.785 8.88675 11.8352 8.8875 11.8975C8.8875 11.9597 8.93775 12.01 9 12.01C9.06225 12.01 9.1125 11.9597 9.1125 11.8975C9.1125 11.836 9.06225 11.785 8.99925 11.785"
      stroke="#321083"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.2441 4.81836C17.3276 7.58736 17.3276 11.4131 15.2441 14.1821"
      stroke="#321083"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.75012 14.1821C0.666625 11.4131 0.666625 7.58736 2.75012 4.81836"
      stroke="#321083"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg></div>
  )
}

export default Active